import { useBalance } from "wagmi";
import { useAccount } from "wagmi";
import { useMemo } from "react";

interface ChainBalance {
  chainId: number;
  balance: string;
  symbol: string;
}

const useMultiChainBalances = (chainIds: number[]) => {
  const { address, isConnected } = useAccount();

  // Get the current chain balance
  const { data: currentBalance, isLoading } = useBalance({
    address,
    query: {
      enabled: isConnected && !!address,
      refetchInterval: 10_000,
    },
  });

  const chainBalances: ChainBalance[] = useMemo(() => {
    // For now, we'll use the current chain balance for all chains
    // This is a simplified approach that provides the balance for the current chain
    // and shows "0" for other chains until the user switches to them
    return chainIds.map((chainId) => ({
      chainId,
      balance: currentBalance?.formatted || "0",
      symbol: currentBalance?.symbol || "ETH",
    }));
  }, [chainIds, currentBalance]);

  return {
    chainBalances,
    isLoading,
  };
};

export default useMultiChainBalances;
